import { OkrManager } from '@workboard/ui-okr';
import { useLegacyOkrPopupHandlers } from '../hooks/useOkrPopupHandlers';


export const ConnectedOkrManager = ({children}) => {
  const { handleOkrDetailPopup } = useLegacyOkrPopupHandlers();
  const { first_name, last_name, picture, user_id } = window?.uData ?? { first_name: '', last_name: '', picture: '', user_id: '' };
  const { userLicenseType, userLicenseOrgFeatureFlag } = window?.wbConfig ?? {};
  const isReadOnly = userLicenseOrgFeatureFlag && userLicenseType === '0';

  const handleToast = (e) => {
    if (e.type === 'error') {
      toastr.error(e.message);
    } else {
      const copyObjectivesReg = /\/wb\/okrs\/objectives\/\d*$/;
      const copyKeyResultsReg = /\/wb\/goal\/krDetails\?id=\d*$/;
      if(
        typeof e.message === 'object' && 
        e.message?.props?.href && 
        (copyObjectivesReg.test(e.message.props.href) || copyKeyResultsReg.test(e.message.props.href))
      ) {
        toastr.success('Link copy to clipboard');
    
      } else {
        toastr.success(e.message);
      }
    }
  };

  const linkRefSrc = window.location.pathname.includes(
    '/wb/okrs/details/person',
  )
    ? 'OSP'
    : 'OLP';

  const uploadFile = (file) => window.FUS.uploadFile(file)

  return (
    <OkrManager
      baseUrl="/wb/vnext/okr"
      currentUser={{
        id: user_id,
        fullName: `${first_name} ${last_name}`,
        picture: picture || '',
        isReadOnly,
      }}
      onToast={handleToast}
      uploadFile={uploadFile}
      options={{
        keyResult: {
          linkRef: 'PAGE_TYPE_OKR_I_OWN',
          linkRefSrc,
        },
        objectives: {
          onOpenOKR: handleOkrDetailPopup,
        },
      }}
    >
      {children}
    </OkrManager>
  );
}
